<template>
  <b-modal id="online_confirm_error" :title="trans('title')" ok-disabled cancel-disabled>
    <p>{{ trans('text') }}</p>

    <template slot="modal-footer">
      <base-button v-for="btn in btns" :key="btn.id" class="orange-white"
                   :text="trans(btn.key)" @click="exec(btn)"
      />
    </template>
  </b-modal>
</template>

<script>
import baseButton from '@/components/backoffice/button/base'
import CommonApi from '@/api/commonApi'

export default {
  components: {
    baseButton
  },

  props: {
    bookingId: {
      type: Number,
      required: true
    }
  },

  data () {
    return {
      btns: [
        { key: 'giveUp', route: {name: 'home'} },
        { key: 'offline', route: {name: 'offline_home'} },
        //{ key: 'restart', route: {name: 'online_results'} }
      ],
      api: new CommonApi()
    }
    
  },

  methods: {
    trans (key) { return this.$t(`online.confirmError.${key}`) },

    redirect (route) { this.$router.push(route) },

    disable () { this.api.disableBooking(this.bookingId) },

    exec (btn) {
      this.disable()
      this.redirect(btn.route)
    }
  }
}
</script>
